export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        {/* Top Row */}
        <div className="flex justify-between items-center mb-16 pb-8 border-b border-white/20">
          <div className="flex items-center gap-3">
            <img src="https://public.readdy.ai/ai/img_res/6db6d4e6-87fa-46b4-8c7e-e3bfc96e3d8e.png" alt="OGIN d.o.o." className="h-8 w-8 object-contain" />
            <span className="text-lg font-medium">OGIN d.o.o.</span>
          </div>
          <p className="text-sm text-white/80">Crafting secure iOS experiences</p>
        </div>

        {/* Middle Section */}
        <div className="grid grid-cols-4 gap-12 mb-16">
          {/* Products */}
          <div>
            <h4 className="text-base font-medium uppercase tracking-wide mb-6">PRODUCTS</h4>
            <ul className="space-y-4">
              <li><a href="#products" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">VPN Protection</a></li>
              <li><a href="#products" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Device Cleaner</a></li>
              <li><a href="#products" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Security Suite</a></li>
              <li><a href="#features" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">All Features</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-base font-medium uppercase tracking-wide mb-6">COMPANY</h4>
            <ul className="space-y-4">
              <li><a href="#about" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#contact" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Careers</a></li>
              <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Press Kit</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-base font-medium uppercase tracking-wide mb-6">RESOURCES</h4>
            <ul className="space-y-4">
              <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Documentation</a></li>
              <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Support Center</a></li>
              <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Terms of Service</a></li>
            </ul>
          </div>

          {/* Copyright */}
          <div className="text-right">
            <p className="text-lg font-medium mb-2" style={{ fontFamily: 'Georgia, serif' }}>© OGIN d.o.o. 2025</p>
            <p className="text-sm text-white/70 mb-6">All rights reserved</p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/20 flex justify-between items-center">
          <div className="text-sm text-white/70">
            <p>Vijenac Ive Marinkovica 2, Ogulin 47300, Croatia</p>
            <p className="mt-2">support@ogindoo.com • +1 6812558616</p>
          </div>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
